<div class="tw-text-center tw-pt-20">
  <h1 class="tw-text-5xl tw-font-bold">There was an error authenticating!</h1>
  <button mat-stroked-button (click)="tryAgain()" class="!tw-m-4">Try Again</button>
  <button mat-stroked-button (click)="goToOkta()">Go to Okta</button>
</div>
